<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'> إدارة الجلسات</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم ادارة عمليات الدخول والخروج من الموقع والتطبيق
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class="input-group">
                <select class="form-control" v-model="branche">
                  <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
                <span class="input-group-btn">
                  <button @click='GetData()' style="height :34px" class="btn btn-warning btn-sm" id="btn-chat">
                    تحديث
                  </button>
                </span>
              </div>
              <br>
              <div id="contentToPrint">
                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>
                      <th align='center' rowspan="2" style='vertical-align: middle;text-align: center'>م</th>
                      <th align='center' rowspan="2" style='vertical-align: middle;text-align: center'>الاسم</th>
                      <th align='center' rowspan="2" style='vertical-align: middle;text-align: center'>الوظيفة</th>
                      <th align='center' rowspan="2" style='vertical-align: middle;text-align: center'>المجموعة</th>
                      <th align='center' colspan="2" style='vertical-align: middle;text-align: center'>الصلاحية</th>
                      <th align='center' rowspan="2" style='vertical-align: middle;text-align: center'>الحالة</th>
                      <th align='center' rowspan="2" style='vertical-align: middle;text-align: center'>آخر حركة</th>
                      <th align='center' rowspan="2" style='vertical-align: middle;text-align: center'>آخر إجراء</th>
                    </tr>
                    <tr>
                      <th style="text-align: center">الموقع</th>
                      <th style="text-align: center">التطبيق</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class='odd gradeX' v-for='(record,index) in records' :key='record.id'>

                      <td align='center'>{{index +1 }}</td>
                      <td align='center'>{{record.name}}</td>
                      <td align='center'>{{record.job}}</td>
                      <td align='center'>{{record.permission_id}}</td>
                      <td align='center'>
                        <label class="switch">
                          <input type="checkbox" @click="Save_Data(record.id,0,record.site_auth)" v-model="record.site_auth" >
                          <span class="slider round"></span>
                        </label>
                      </td>
                      <td align='center'>
                        <label class="switch">
                          <input type="checkbox" @click="Save_Data(record.id,1,record.mob_auth)" v-model="record.mob_auth" >
                          <input type="checkbox" v-model="record.mob_auth" >
                          <span class="slider round"></span>
                        </label>
                      </td>
                      <td v-if="record.login_status === '0' " align='center'> <i class="fa fa-power-off" style="font-size:20px;color:#cccccc"></i></td>
                      <td v-if="record.login_status === '1' " align='center'>
                        <button type="button" @click="Save_Data(record.id,2)" class="btn btn-default btn-circle"><i class="fa fa-power-off" style="font-size:20px;color:#2196f3"></i>
                        </button>
                       </td>
                      <td align='center'>
                        <h6>{{record.last_action_date}}
                          <p class="text-success"><small>D:{{record.d}} H:{{record.h}} M:{{record.m}} S:{{record.s}}</small></p>
                        </h6>
                      </td>
                      <td align='center'>{{record.last_action}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'sessions',
  data () {
    return {
      validationErrors: '',
      records: {},
      branches: {},
      branche: 0,
      isLoadingData: false
    }
  },
  created () {
    this.branche = localStorage.getItem('BrancheID')
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.GetData()
  },
  methods: {
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getDataSessions', {
        token: localStorage.getItem('token'),
        branche_id: this.branche
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    Save_Data (id, type, val) {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'changeStatue', {
        token: localStorage.getItem('token'),
        id: id,
        type: type,
        branche_id: this.branche,
        val: val
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    }
  }
}
</script>
<style media="screen">
/* The switch - the box around the slider */
.switch {
position: relative;
display: inline-block;
width: 30px;
height: 17px;
}

/* Hide default HTML checkbox */
.switch input {
opacity: 0;
width: 0;
height: 0;
}

/* The slider */
.slider {
position: absolute;
cursor: pointer;
top: 0;
left: 0;
right: 0;
bottom: 0;
background-color: #ccc;
-webkit-transition: .4s;
transition: .4s;
}

.slider:before {
position: absolute;
content: "";
height: 13px;
width: 13px;
left: 2px;
bottom: 2px;
background-color: white;
-webkit-transition: .4s;
transition: .4s;
}

input:checked + .slider {
background-color: #2196F3;
}

input:focus + .slider {
box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
-webkit-transform: translateX(13px);
-ms-transform: translateX(13px);
transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
border-radius: 17px;
}

.slider.round:before {
border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/Sessions.vue